export default "__VITE_ASSET__71a622f2__"